<template>
  <div class="header">
    <b-navbar toggleable="lg" type="light" >
      <b-navbar-brand href="#">DYO ADMIN</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <!--<b-nav-item href="#">Link</b-nav-item>-->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto f-sb">
          <b-nav-item href="/dashboard/">Home</b-nav-item>
          <b-nav-item-dropdown text="Customers" right>
            <b-dropdown-item href="/customers/">Manage Customer</b-dropdown-item>
            <b-dropdown-item href="/orders/">Manage Orders</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Products" right>
            <b-dropdown-item href="/products">Manage Products</b-dropdown-item>
            <b-dropdown-item href="/product/category">Manage Category</b-dropdown-item>
            <b-dropdown-item href="/product/colors">Manage Product Colors</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="/data-sources/">Data Sources</b-nav-item>
          <b-nav-item-dropdown text="Design Your Own" right>
            <b-dropdown-item href="/dyo/category">DYO Category</b-dropdown-item>
            <b-dropdown-item href="/dyo/colors">DYO Colors</b-dropdown-item>
            <b-dropdown-item href="/dyo/artwork/colors" v-if="$root.chkperm('colors','enabled')">DYO Artwork Colors</b-dropdown-item>
            <b-dropdown-item href="/dyo/products">DYO Products</b-dropdown-item>
            <b-dropdown-item href="/dyo/designs">DYO Designs</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Settings" v-if="$root.chkperm('colors','enabled') && $root.chkperm('users','enabled')" right>
            <b-dropdown-item href="/artwork/colors" v-if="$root.chkperm('colors','enabled')">Manage Colors</b-dropdown-item>
            <b-dropdown-item href="/users" v-if="$root.chkperm('users','enabled')">Manage Users</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="/action/">Action</b-nav-item>
          <b-nav-item-dropdown text="Report" right>
            <b-dropdown-item href="#">Order Report</b-dropdown-item>
            <b-dropdown-item href="#">Activity Report</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>{{$session.get('user_info').username}}</em>
            </template>
            <b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
            <b-dropdown-item href="/logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
      <b-modal id="cp-modal" title="Change Password" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
            <b-form-input v-model="current_password" type="password"  required></b-form-input>
          </b-form-group>
          <b-form-group label="New Password" label-cols="4" label-size="sm" label-align-sm="right">
            <b-form-input v-model="new_password" type="password" :state="passwordState" required></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 4 letters
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
        <template v-slot:modal-footer="{ ok, close }">
          <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
          <b-button size="sm" variant="success" @click="ok()">Update</b-button>
        </template>
      </b-modal>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
      current_password: '', 
      new_password: '',
      passwordUrl: 'http://localhost:3000/api/change-password',
    }
  },
  methods:{
    resetSelectedItem(){
      this.current_password = '';
      this.new_password = '';
    },
    modalSubmit(bvModalEvt){
      var self = this;
      //self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = self.passwordUrl;

      var o = {'cp': this.current_password, 'np': this.new_password};

      self.axios.post(submitUrl, {
        accesskey: self.$session.get('access_key'),
        data: o
      })
      .then(function (response) {
        if(response.data.error == 0 || response.data.error == '0'){
          self.$bvModal.hide('my-modal');
          self.$bvToast.toast(response.data.message, {
            title: 'Status',
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 5000,
            variant: 'warning',
            solid: true,
            appendToast: true
          });
        }
        
      })
      .catch(function (error) {
        alert(error);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.header{
  position: fixed;
  top:0px;
  width: 100%;
  z-index: 10;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}


</style>
